import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { CheckboxElement, CheckboxValue } from '@fulcrumapp/fulcrum-core';

interface Props {
  element: CheckboxElement;
  value: CheckboxValue;
  onChange: (value: CheckboxValue) => void;
}

const CheckboxField = ({ element, value, onChange }: Props) => {
  const checkboxValue = value || new CheckboxValue(element, false);

  const [checked, setChecked] = useState(checkboxValue.isChecked);

  useEffect(() => {
    onChange(new CheckboxValue(checkboxValue.element, checked));
  }, [checked]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  return (
    <>
      <FormControl fullWidth>
        <FormControlLabel
          control={(
            <Checkbox
              name={element.label}
              checked={checked}
              onChange={handleChange}
            />
          )}
          label={element.label}
        />
      </FormControl>
    </>
  );
};

export default CheckboxField;
